module.exports = __webpack_public_path__ + "img/mariage.6927b01e.jpg";